<template>
    <span v-if="lastSeen == null || lastSeen == 'undefined'">
        _
    </span>
    <span v-else-if="(new Date(Date.now() - 86400000).toISOString() > lastSeen)"
         class="rounded text-center text-nowrap text-danger bg-danger bg-opacity-10 align-baseline px-2 py-1">
        <font-awesome-icon :icon="['fas', 'triangle-exclamation']" /> {{ $filters.timeAgo(lastSeen) }}
    </span>
    <span v-else class="text-muted">
        {{ $filters.timeAgo(lastSeen) }}
    </span>
</template>

<script>
export default {
    props: ['lastSeen'],
}
</script>